import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Donate.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import Donate from "../../assets/images/Donate.jpg"
import QR from "../../assets/images/qr.jpg"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>DONATE</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={Donate} alt="Donate" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
             <section className="Donate_us mt-4 pt-5">
            <div className="container-fluid custom_container_inner">
                <h2>Bank Details</h2>
                  <div className="row">
                      <div className="col-md-6 col-sm-12 col-12">
                      <div className="Contact_us_text">
                        <h1>Jayam charitable trust </h1></div>
                     <div className="Contact_us_text">
                        <h3>CA :<span>510909010276072</span></h3>
                     </div>
                     <div className="Contact_us_text">
                        <h3>Ifs code : <span>CIUB0000218</span></h3>
                     </div>
                     <div className="Contact_us_text">
                        <h1>CITY UNION BANK LTD</h1>
                     </div>
                      </div>
                      <div className="col-md-6 col-sm-12 col-12">
                          <img src={QR} alt="QR" className="img-fluid"/>
                      </div>
                  </div>
                  
                
                  
              
            </div>         
           </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
